import { useFlag, useVariant } from '@unleash/nextjs'
import React from 'react'

type TSubsection = {
  number: string
  content: string
  subsections?: TSubsection[]
}

type TSection = {
  section: string
  subsections: TSubsection[]
}

type TAgreementContentRendererProps = {
  content: readonly TSection[]
}

type TSubsectionListProps = {
  subsections: readonly TSubsection[]
}

const SubsectionList = ({ subsections }: Readonly<TSubsectionListProps>) => {
  return (
    <ul className='mt-2 flex-col gap-2'>
      {subsections.map((subsubsection) => (
        <li key={subsubsection.number} className='mt-2'>
          {subsubsection.number}
          {subsubsection.number && '. '}
          <span dangerouslySetInnerHTML={{ __html: subsubsection.content }} />
        </li>
      ))}
    </ul>
  )
}

const AgreementContentRenderer = ({ content }: Readonly<TAgreementContentRendererProps>) => {
  const gopayDeeplink = useFlag('gopayDeeplink')

  const gopayDeeplinkVariant = useVariant('gopayDeeplink')
  return (
    <ol className='flex list-inside list-decimal flex-col gap-4'>
      {content.map((section) => (
        <li key={section.section} className='text-sm font-bold'>
          {section.section}
          <ul className='mt-4 flex list-inside flex-col gap-2 text-xs font-normal'>
            {section.subsections.map((subsection) => (
              <li key={subsection.number}>
                {subsection.number}
                {subsection.number && '. '}
                <span dangerouslySetInnerHTML={{ __html: subsection.content }} />
                {subsection.subsections && <SubsectionList subsections={subsection.subsections} />}
              </li>
            ))}
          </ul>
        </li>
      ))}
      {gopayDeeplink && (
        <button
          type='button'
          className='h-4 w-24 bg-transparent'
          onClick={() => {
            window.open(gopayDeeplinkVariant?.payload?.value, '_self')
          }}
        />
      )}
    </ol>
  )
}

export default AgreementContentRenderer
